const sectionCode = "SPRO2";
const chartCode = "C017x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T17Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T17Procedures };
